import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/LanguageContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PropertiesPage from "@/pages/PropertiesPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import ListPropertyPage from "@/pages/ListPropertyPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import OwnerPage from "@/pages/OwnerPage";
import OwnerSuccessPage from "@/pages/OwnerSuccessPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-bone">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="properties" element={<PropertiesPage />} />
              <Route path="property/:id" element={<PropertyDetailPage />} />
              <Route path="list-property" element={<ListPropertyPage />} />
              <Route path="owner" element={<OwnerPage />} />
              <Route path="owner/success" element={<OwnerSuccessPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
